import { memo, useMemo } from 'react';

const Copy = memo(({ className, color = '#FF576D', size = '16' }: any) =>
  useMemo(
    () => (
      <div className={className}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          viewBox="0 0 20 20"
          fill="none"
        >
          <g clipPath="url(#clip0_70174_66438)">
            <path
              d="M8.86393 3.33301L14.47 3.33301C14.912 3.33301 15.3359 3.5086 15.6485 3.82116C15.9611 4.13372 16.1367 4.55765 16.1367 4.99967V12.4997C16.1367 12.9417 15.9611 13.3656 15.6485 13.6782C15.3359 13.9907 14.912 14.1663 14.47 14.1663H8.86393C8.4219 14.1663 7.99798 13.9907 7.68542 13.6782C7.37286 13.3656 7.19727 12.9417 7.19727 12.4997V4.99967C7.19727 4.55765 7.37286 4.13372 7.68542 3.82116C7.99798 3.5086 8.4219 3.33301 8.86393 3.33301Z"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.8037 14.167V15.8337C12.8037 16.2757 12.6281 16.6996 12.3155 17.0122C12.0029 17.3247 11.579 17.5003 11.137 17.5003H5.53092C5.0889 17.5003 4.66497 17.3247 4.35241 17.0122C4.03985 16.6996 3.86426 16.2757 3.86426 15.8337V8.33366C3.86426 7.89163 4.03985 7.46771 4.35241 7.15515C4.66497 6.84259 5.0889 6.66699 5.53092 6.66699H7.19759"
              stroke="#AAABAB"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_70174_66438">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    ),
    [className],
  ),
);

export default Copy;
